







































































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import RecordChart, { ChartData, LineItem, SubjectRecord } from '@/components/record/recordChart.vue';
import ItemSelect from '@/components/itemSelect.vue';
import { Grades, PointsData, SearchCondition, EditGrades } from '@/modules/recordView';
import { Subject } from '@/models/subject';
import { SchoolTypes } from '@/enums/schoolTypes';
import { GradesTypes, getGradesTypeName } from '@/enums/gradesTypes';
import { SchoolTerms } from '@/enums/schoolTerms';
import { GradeYears } from '@/enums/gradeYears';

interface ListData extends Grades {
  gradesId: string | null;
  gradeYear: GradeYears;
  gradeYearName: string;
  schoolTerm: SchoolTerms;
  schoolTermName: string;
  fiscalYear: number;
  testTimes: number;
  testTimesName: string;
}

@Component({
  components: {
    'record-chart': RecordChart
  }
})
export default class RecordViewContent extends Vue {
  private SchoolTypes = SchoolTypes;
  private GradesTypes = GradesTypes;
  private getGradesTypeName = getGradesTypeName;

  @Prop({ required: true }) private type: number;
  @Prop() private studentId: string;
  @Prop() private selectedSchoolType: number;
  @Prop() private selectedOtherTest: string;
  @Prop() private isChanged: boolean;

  private isChangedModel = false;
  private chartMinWidth = 0;

  get loading(): boolean {
    switch (this.type as GradesTypes) {
      case GradesTypes.Report:
        return this.$store.state.recordView.report.loading;
      case GradesTypes.RoutineTest:
        return this.$store.state.recordView.routineTest.loading;
      case GradesTypes.OtherTest:
        return this.$store.state.recordView.otherTest.loading;
      default:
        return this.$store.state.recordView.report.loading;
    }
  }

  get subjects(): Subject[] {
    const data = this.viewListData;
    if (!data || data.length === 0) {
      return [];
    } else {
      return data.reduce((list, item) => {
        item.pointsList.forEach((points) => {
          if (!list.find((check) => check.id === points.subject)) {
            list.push({
              id: points.subject,
              name: points.subjectName,
              color: points.subjectColor,
            });
          }
        });
        return list;
      }, new Array<Subject>()).sort((a, b) => {
        if (a.id < b.id) { return -1; }
        if (a.id > b.id) { return 1; }
        return 0;
      });
    }
  }

  get grades(): Grades {
    switch (this.type as GradesTypes) {
      case GradesTypes.Report:
        return this.$store.state.recordView.report.grades;
      case GradesTypes.RoutineTest:
        return this.$store.state.recordView.routineTest.grades;
      case GradesTypes.OtherTest:
        return this.$store.state.recordView.otherTest.grades;
      default:
        return this.$store.state.recordView.report.grades;
    }
  }

  get viewListData(): ListData[] {
    const data = this.grades;
    if (!data) {
      return [];
    } else {
      let sortData: PointsData[];
      switch (this.type as GradesTypes) {
        case GradesTypes.Report:
        case GradesTypes.RoutineTest:
          sortData = data.pointsList.sort((a, b) => {
            if (a.gradeYear < b.gradeYear) { return -1; }
            if (a.gradeYear > b.gradeYear) { return 1; }
            if (a.schoolTerm < b.schoolTerm) { return -1; }
            if (a.schoolTerm > b.schoolTerm) { return 1; }
            if (!a.gradesId) { return -1; }
            if (!b.gradesId) { return 1; }
            if (a.gradesId < b.gradesId) { return -1; }
            if (a.gradesId > b.gradesId) { return 1; }
            return 0;
          });
          break;
        default: // case GradesTypes.OtherTest:
          sortData = data.pointsList.sort((a, b) => {
            if (a.fiscalYear < b.fiscalYear) { return -1; }
            if (a.fiscalYear > b.fiscalYear) { return 1; }
            if (a.testTimes < b.testTimes) { return -1; }
            if (a.testTimes > b.testTimes) { return 1; }
            if (!a.gradesId) { return -1; }
            if (!b.gradesId) { return 1; }
            if (a.gradesId < b.gradesId) { return -1; }
            if (a.gradesId > b.gradesId) { return 1; }
            return 0;
          });
      }
      return Array.from(sortData.reduce((list, item) => {
        const key = `${item.gradesId}|${item.gradeYear}|${item.schoolTerm}|${item.fiscalYear}|${item.testTimes}`;
        let grades = list.get(key);
        if (!grades) {
          grades = {
            gradesId: item.gradesId,
            ordinarySchoolId: data.ordinarySchoolId,
            ordinarySchoolName: data.ordinarySchoolName,
            studentId: data.studentId,
            studentUserId: data.studentUserId,
            studentName: data.studentName,
            schoolType: data.schoolType,
            gradesType: data.gradesType,
            gradesTypeName: data.gradesTypeName,
            testType: data.testType,
            testTypeName: data.testTypeName,
            gradeYear: item.gradeYear,
            gradeYearName: item.gradeYearName,
            schoolTerm: item.schoolTerm,
            schoolTermName: item.schoolTermName,
            fiscalYear: item.fiscalYear,
            testTimes: item.testTimes,
            testTimesName: item.testTimesName,
            pointsList: new Array<PointsData>(),
            isRecordChanged: false,
          };
          list.set(key, grades);
        }
        grades.pointsList.push(item);
        return list;
      }, new Map<string, ListData>()).values());
    }
  }

  get condition(): SearchCondition {
    switch (this.type as GradesTypes) {
      case GradesTypes.Report:
        return this.$store.state.recordView.report.searchCondition;
      case GradesTypes.RoutineTest:
        return this.$store.state.recordView.routineTest.searchCondition;
      case GradesTypes.OtherTest:
        return this.$store.state.recordView.otherTest.searchCondition;
      default:
        return this.$store.state.recordView.report.searchCondition;
    }
  }

  get isMini(): boolean {
    return (this as any).$mq === 'mini';
  }

  public async viewData() {
    switch (this.condition.gradesType) {
      case GradesTypes.Report:
      case GradesTypes.RoutineTest:
        if (this.condition.schoolType === SchoolTypes.All) {
          return;
        }
        break;
      case GradesTypes.OtherTest:
        if (this.condition.schoolType === SchoolTypes.All) {
          return;
        }
        if (this.condition.testType === '') {
          return;
        }
        break;
    }
    try {
      await this.$store.dispatch('recordView/getGradesDetail', {
        studentId: this.studentId,
        searchCondition: this.condition
      });
    } catch (error) {
      throw error;
    }
  }

  @Watch('condition.schoolType')
  private onChangeItemSchoolType(val: SchoolTypes) {
    this.$emit('update:selectedSchoolType', val);
  }

  @Watch('selectedSchoolType')
  private onChangePropSelectedSchoolType(val: SchoolTypes) {
    this.condition.schoolType = val;
  }

  @Watch('condition.testType')
  private onChangeItemTestType(val: string) {
    this.$emit('update:selectedOtherTest', val);
  }

  @Watch('selectedOtherTest')
  private onChangePropselectedOtherTest(val: string) {
    this.condition.testType = val;
  }

  @Watch('grades', { deep: true })
  private changeGrades() {
    this.viewChart();
  }

  private created() {
    this.condition.schoolType = this.selectedSchoolType;
    this.condition.testType = this.selectedOtherTest;
  }

  private viewChart() {
    const chart = this.$refs.chart as RecordChart;
    const data = this.getChartData();
    this.chartMinWidth = (50 * data.times.length);
    chart.viewChart(data);
  }

  private getChartData(): ChartData {
    let gradesType: GradesTypes;
    let pointsList: PointsData[];
    if (!this.grades) {
      gradesType = GradesTypes.Report;
      pointsList = new Array<PointsData>();
    } else {
      gradesType = this.grades.gradesType;
      pointsList = this.grades.pointsList;
    }

    let dataSubjects: LineItem[] = pointsList.map((item) => {
      return {
        id: String(item.subject),
        name: item.subjectName,
        color: item.subjectColor,
      };
    });
    dataSubjects = dataSubjects.filter((value, index) => {
      return index === dataSubjects.findIndex((item) => item.id === value.id);
    });

    let dataTimes: LineItem[] = pointsList.map((item) => {
      let id: string;
      let name: string | string[];
      switch (gradesType) {
        case GradesTypes.Report:
        case GradesTypes.RoutineTest:
          id = `${item.gradeYear}|${item.schoolTerm}`;
          name = [item.gradeYearName, item.schoolTermName];
          break;
        default: // case GradesTypes.OtherTest:
          id = `${item.fiscalYear}|${item.testTimes}`;
          name = [`${item.fiscalYear}年度`, item.testTimesName];
      }
      return {
        id,
        name,
        color: '',
      };
    });
    dataTimes = dataTimes.filter((value, index) => {
      return index === dataTimes.findIndex((item) => item.id === value.id);
    });

    const dataRecords = new Array<SubjectRecord>();
    pointsList.forEach((pointsData) => {
      const subjectId = String(pointsData.subject);
      let timesId: string;
      switch (gradesType) {
        case GradesTypes.Report:
        case GradesTypes.RoutineTest:
          timesId = `${pointsData.gradeYear}|${pointsData.schoolTerm}`;
          break;
        default: // case GradesTypes.OtherTest:
          timesId = `${pointsData.fiscalYear}|${pointsData.testTimes}`;
      }
      let data = dataRecords.find((item) => {
        return item.subjectId === subjectId;
      });
      if (!data) {
        data = {
          subjectId,
          records: [],
        };
        dataRecords.push(data);
      }
      data.records.push({
        timesId,
        score: !pointsData.points ? undefined : pointsData.points
      });
    });

    return {
      type: gradesType,
      subjects: dataSubjects,
      times: dataTimes,
      records: dataRecords
    };
  }

  private onChangeSchoolType() {
    switch (this.type) {
      case GradesTypes.Report:
      case GradesTypes.RoutineTest:
        this.viewData();
        break;
      case GradesTypes.OtherTest:
        // 模試の変更が連動してonChangeOtherTestが発生する
        break;
    }
  }

  private onChangeOtherTest() {
    if (this.condition.testType === '') {
      const items = (this.$refs.otherTestItemSelect as ItemSelect).Items;
      if (items.length > 0) {
        this.condition.testType = items[0].id as string;
      }
    }
    this.viewData();
  }

  private schoolYearFormatter(row: PointsData) {
    return `${row.fiscalYear}年度`;
  }

  private onKeyPressScore(e: KeyboardEvent) {
    const theEvent = e || window.event;
    const key = theEvent.keyCode || theEvent.which;
    if ((key < 48 || key > 57) && !(key === 8 || key === 9 || key === 13 || key === 37 || key === 39)) {
      theEvent.returnValue = false;
      if (theEvent.preventDefault) {
        theEvent.preventDefault();
      }
    }
  }

  private onChangeScore(row: Grades, subjectId: number, e: any) {
    const record = row.pointsList.find((item) => {
      return (item.subject === subjectId);
    });
    if (!record) {
      return;
    }
    const value = e.currentTarget.value.replace(/[^\d]/, '');
    if (value === '') {
      record.points = null;
    } else {
      const num = Number(value);
      if (isNaN(num)) {
        record.points = null;
      } else {
        record.points = num;
      }
    }
    e.currentTarget.value = record.points;

    row.isRecordChanged = !!row.pointsList.find((item) => {
      return (item.points !== item.beforePoints);
    });
    this.checkChanged();
  }

  private checkChanged() {
    const isChanged = !!this.viewListData.find((item) => {
      return item.isRecordChanged;
    });
    if (this.isChangedModel !== isChanged) {
      this.isChangedModel = isChanged;
      this.$emit('update:isChanged', this.isChangedModel);
    }
  }

  private async onRegist(row: Grades) {
    if (!row.isRecordChanged || row.pointsList.length === 0) { return; }

    // 登録処理
    try {
      const gradesTarget = row.pointsList[0];
      const editData: EditGrades = {
        gradesId: gradesTarget.gradesId,
        gradesCollectionId: gradesTarget.gradesCollectionId,
        studentId: row.studentId,
        gradeYear: gradesTarget.gradeYear,
        schoolTerm: gradesTarget.schoolTerm,
        pointList: row.pointsList.filter((item) => item.points !== item.beforePoints)
          .map((item) => ({
              subject: item.subject,
              points: item.points
            })
          ),
      };
      await this.$store.dispatch('recordList/editGrades', editData);

      row.pointsList.forEach((item) => {
        item.beforePoints = item.points;
      });
      row.isRecordChanged = false;

      this.$notify({
        title: '登録完了',
        message: `生徒『${row.studentName}』の成績を登録しました。`,
        position: 'bottom-right'
      });
    } catch (error) {
      this.$notify({
        title: 'エラー',
        message: `生徒『${row.studentName}』の成績の登録に失敗しました。`,
        position: 'bottom-right'
      });
    }
    this.checkChanged();
  }

}
